<template>
<div class="container">
<div class="payment-list">
  <div class="cart" v-if="tab=='payment'">
    <ul>
      <li v-for="(item, ii) in cartItems">
        <span class="subtitle">{{ item?.ticket?.event?.title }}</span>
        <span class="title">{{ item?.ticket?.props?.title }} x{{ item?.qty }}</span>
        <span class="price">{{ formatPrice(item?.price) }}</span>
        <a class="remove" href="" v-on:click.prevent="popItem(ii)">&times;</a>
      </li>
      <li v-if="discountObj">
        <span class="subtitle">Discount: {{ discountObj.title }}</span>
        <span class="title"></span>
        <span class="price">- {{ formatPrice(discountObj.props?.discountAmount?.content) }}</span>
        <a class="remove" href="" v-on:click.prevent="">&nbsp;&nbsp;</a>
      </li>
    </ul>

    <div class="total" v-if="cartItems && cartItems.length">
      <span class="total-price">{{ formatPrice(totalPrice) }}</span>
      <span class="label">IN TOTAL</span>
    </div>




  </div>
  <div class="payment-form">
    <template v-if="tab=='payment'">
      <form class="user-form login" v-on:submit.prevent="savePayment">
        <div class="uf-row">
          <label>First Name:</label>
          <input type="text" v-model="userProfile.firstname" required>
        </div>
        <div class="uf-row">
          <label>Last Name:</label>
          <input type="text" v-model="userProfile.lastname" required>
        </div>
        <div class="uf-row">
          <label>Address:</label>
          <input type="text" v-model="userProfile.address" required>
        </div>
        <div class="uf-row">
          <label>City:</label>
          <input type="text" v-model="userProfile.city" required>
        </div>
        <div class="uf-row">
          <label>Zip/Postal Code:</label>
          <input type="text" v-model="userProfile.postal" required>
        </div>
        <div class="uf-row">
          <label>Province:</label>
          <input type="text" v-model="userProfile.province" required>
        </div>
        <div class="uf-row">
          <label>Country:</label>
          <select type="text" v-model="userProfile.country" required>
            <option v-for="country in countries">{{ country }}</option>
          </select>
        </div>
        <div class="uf-row">
          <label>Phone:</label>
          <input type="text" v-model="userProfile.phone" required>
        </div>
        <div class="uf-row">
          <label>Email:</label>
          <input type="text" v-model="userProfile.email" required>
        </div>
        <div class="uf-row to-c">
          <button class="main">Pay now</button>
        </div>
      </form>
    </template>
    <template v-if="tab=='payment2'">
      <div style="" v-if="paymentReady">
        <iframe :src="paymentReady" class="payframe" style="height: 900px; width: 100%"></iframe>
      </div>
      <div v-else class="loading">
        <span>Preparing your payment</span>
      </div>
    </template>



  </div>

</div>
</div>
</template>
<script>
import api from './api';
import Cookies from 'js-cookie';
import formatters from './formatters';
export default {
  mixins: [formatters],
  data: ()=>({
    tab: 'payment',
    package: null,
    paymentReady: null,
    detailsSaved: false,
    agreed: false,
    success: false,
    userProfile: {},
    countries: [
      "Afghanistan",
      "Albania",
      "Algeria",
      "American Samoa",
      "Andorra",
      "Angola",
      "Anguilla",
      "Antarctica",
      "Antigua and Barbuda",
      "Argentina",
      "Armenia",
      "Aruba",
      "Australia",
      "Austria",
      "Azerbaijan",
      "Bahamas",
      "Bahrain",
      "Bangladesh",
      "Barbados",
      "Belarus",
      "Belgium",
      "Belize",
      "Benin",
      "Bermuda",
      "Bhutan",
      "Bolivia",
      "Bosnia and Herzegovina",
      "Botswana",
      "Bouvet Island",
      "Brazil",
      "British Indian Ocean Territory",
      "Brunei",
      "Bulgaria",
      "Burkina Faso",
      "Burundi",
      "Cambodia",
      "Cameroon",
      "Canada",
      "Cape Verde",
      "Cayman Islands",
      "Central African Republic",
      "Chad",
      "Chile",
      "China",
      "Christmas Island",
      "Cocos (Keeling) Islands",
      "Colombia",
      "Comoros",
      "Congo",
      "Cook Islands",
      "Costa Rica",
      "Croatia",
      "Cuba",
      "Cyprus",
      "Czech Republic",
      "Denmark",
      "Djibouti",
      "Dominica",
      "Dominican Republic",
      "East Timor",
      "Ecuador",
      "Egypt",
      "El Salvador",
      "Equatorial Guinea",
      "Eritrea",
      "Estonia",
      "Ethiopia",
      "Falkland Islands",
      "Faroe Islands",
      "Fiji Islands",
      "Finland",
      "France",
      "French Guiana",
      "French Polynesia",
      "French Southern territories",
      "Gabon",
      "Gambia",
      "Georgia",
      "Germany",
      "Ghana",
      "Gibraltar",
      "Greece",
      "Greenland",
      "Grenada",
      "Guadeloupe",
      "Guam",
      "Guatemala",
      "Guernsey",
      "Guinea",
      "Guinea-Bissau",
      "Guyana",
      "Haiti",
      "Heard Island and McDonald Islands",
      "Holy See (Vatican City State)",
      "Honduras",
      "Hong Kong",
      "Hungary",
      "Iceland",
      "India",
      "Indonesia",
      "Iran",
      "Iraq",
      "Ireland",
      "Isle of Man",
      "Israel",
      "Italy",
      "Ivory Coast",
      "Jamaica",
      "Japan",
      "Jersey",
      "Jordan",
      "Kazakhstan",
      "Kenya",
      "Kiribati",
      "Kuwait",
      "Kyrgyzstan",
      "Laos",
      "Latvia",
      "Lebanon",
      "Lesotho",
      "Liberia",
      "Libyan Arab Jamahiriya",
      "Liechtenstein",
      "Lithuania",
      "Luxembourg",
      "Macao",
      "North Macedonia",
      "Madagascar",
      "Malawi",
      "Malaysia",
      "Maldives",
      "Mali",
      "Malta",
      "Marshall Islands",
      "Martinique",
      "Mauritania",
      "Mauritius",
      "Mayotte",
      "Mexico",
      "Micronesia, Federated States of",
      "Moldova",
      "Monaco",
      "Mongolia",
      "Montenegro",
      "Montserrat",
      "Morocco",
      "Mozambique",
      "Myanmar",
      "Namibia",
      "Nauru",
      "Nepal",
      "Netherlands",
      "Netherlands Antilles",
      "New Caledonia",
      "New Zealand",
      "Nicaragua",
      "Niger",
      "Nigeria",
      "Niue",
      "Norfolk Island",
      "North Korea",
      "Northern Ireland",
      "Northern Mariana Islands",
      "Norway",
      "Oman",
      "Pakistan",
      "Palau",
      "Palestine",
      "Panama",
      "Papua New Guinea",
      "Paraguay",
      "Peru",
      "Philippines",
      "Pitcairn",
      "Poland",
      "Portugal",
      "Puerto Rico",
      "Qatar",
      "Reunion",
      "Romania",
      "Russian Federation",
      "Rwanda",
      "Saint Helena",
      "Saint Kitts and Nevis",
      "Saint Lucia",
      "Saint Pierre and Miquelon",
      "Saint Vincent and the Grenadines",
      "Samoa",
      "San Marino",
      "Sao Tome and Principe",
      "Saudi Arabia",
      "Senegal",
      "Serbia",
      "Seychelles",
      "Sierra Leone",
      "Singapore",
      "Slovakia",
      "Slovenia",
      "Solomon Islands",
      "Somalia",
      "South Africa",
      "South Georgia and the South Sandwich Islands",
      "South Korea",
      "South Sudan",
      "Spain",
      "Sri Lanka",
      "Sudan",
      "Suriname",
      "Svalbard and Jan Mayen",
      "Swaziland",
      "Sweden",
      "Switzerland",
      "Syria",
      "Tajikistan",
      "Tanzania",
      "Thailand",
      "The Democratic Republic of Congo",
      "Timor-Leste",
      "Togo",
      "Tokelau",
      "Tonga",
      "Trinidad and Tobago",
      "Tunisia",
      "Turkey",
      "Turkmenistan",
      "Turks and Caicos Islands",
      "Tuvalu",
      "Uganda",
      "Ukraine",
      "United Arab Emirates",
      "United Kingdom",
      "United States",
      "United States Minor Outlying Islands",
      "Uruguay",
      "Uzbekistan",
      "Vanuatu",
      "Venezuela",
      "Vietnam",
      "Virgin Islands, British",
      "Virgin Islands, U.S.",
      "Wallis and Futuna",
      "Western Sahara",
      "Yemen",
      "Zambia",
      "Zimbabwe",
    ],
    discount: null,
  }),
  computed: {
    totalPrice() {
      var discount=0;
      if (this.discountObj)
        discount=this.discountObj.props.discountAmount?.content*1;
      return this.cartItems.map((a)=>a.price*a.qty).reduce((a,b)=>a*1+b*1, 0)-discount;
    },
    cartItems() {
      return window.appCart?.cartItems || [];
    },
    discountObj() {
      return window.appAvailableDiscounts.find(item=>item.props.discountCode?.content==this.discount);
    },
  },
  methods: {
    async savePayment() {
      this.tab='payment2';
      var result=await api.request("POST", location.href, {
        user: this.userProfile,
        cartItems: this.cartItems.map(item=>({id: item.ticket?.id, qty: item.qty})),
        discount: this.discount,
        currency: this.currency,
      });
      if (result.free) {
        this.$router.go(-1);
      } else if (result.url) {
        this.paymentReady=result.url;
        this.tab="payment2";
      } else {
        this.tab='payment';
        alert("Please try again later");
      }
    },
    popItem(index) {
      return window.appCart.popItem(index);
    }
  },
  created() {
    if (this.$attrs.currency)
      this.currency=this.$attrs.currency;
//     this.updateCartItems();
    var matches=window.location.search.match(/discount=([^&]+)/);
    if (matches)
      this.discount=matches[1];
  },
  mounted() {
//     this.savePayment();
  },
}
</script>
